var c=function(n){return n.ACTIVE="active",n.CASUAL="casual",n.NONE_SMOKER="none",n.STRICT_NONE="strict_none",n}({});export{c as SmokerStatus};